import React from 'react'
import MaterialSymbol from '../material-symbol'

const Web = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="web" {...props} />
))

Web.displayName = 'Web'

export default Web
